import React, { useEffect, useState } from "react";

const HOURS = Array.from({ length: 12 }, (_, i) => i + 1);

const MINUTES = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, "0")
);

export default function InlineTimePicker({
  value = "08:30 PM",
  onChange,
}) {
  const parseTime = (time) => {
    const [clock, period] = time.split(" ");
    const [hour, minute] = clock.split(":");

    return {
      hour: parseInt(hour),
      minute,
      period,
    };
  };

  const initial = parseTime(value);

  const [hour, setHour] = useState(initial.hour);
  const [minute, setMinute] = useState(initial.minute);
  const [period, setPeriod] = useState(initial.period);

  useEffect(() => {
    onChange?.(
      `${String(hour).padStart(2, "0")}:${minute} ${period}`
    );
  }, [hour, minute, period]);

  return (
    <div
      className="
        tw-inline-flex
        tw-items-center
        tw-gap-3
        tw-rounded-2xl
        tw-border
        tw-border-cyan-400/20
        tw-bg-[#081120]
        tw-p-3
        tw-shadow-[0_0_30px_rgba(0,255,255,0.08)]
      "
    >
      {/* Hour */}
      <div className="tw-relative">
        <select
          value={hour}
          onChange={(e) => setHour(Number(e.target.value))}
          className="
            tw-h-14
            tw-rounded-xl
            tw-border
            tw-border-white/10
            tw-bg-white/5
            tw-px-4
            tw-pr-10
            tw-text-lg
            tw-font-bold
            tw-text-white
            tw-outline-none
            tw-backdrop-blur-lg
            focus:tw-border-cyan-400/50
            appearance-none
          "
        >
          {HOURS.map((item) => (
            <option
              key={item}
              value={item}
              className="tw-bg-[#081120]"
            >
              {String(item).padStart(2, "0")}
            </option>
          ))}
        </select>

        <div className="tw-pointer-events-none tw-absolute tw-right-3 tw-top-1/2 tw--translate-y-1/2 tw-text-cyan-300">
          ▼
        </div>
      </div>

      {/* Colon */}
      <div className="tw-text-3xl tw-font-bold tw-text-cyan-300">
        :
      </div>

      {/* Minute */}
      <div className="tw-relative">
        <select
          value={minute}
          onChange={(e) => setMinute(e.target.value)}
          className="
            tw-h-14
            tw-rounded-xl
            tw-border
            tw-border-white/10
            tw-bg-white/5
            tw-px-4
            tw-pr-10
            tw-text-lg
            tw-font-bold
            tw-text-white
            tw-outline-none
            tw-backdrop-blur-lg
            focus:tw-border-purple-400/50
            appearance-none
          "
        >
          {MINUTES.map((item) => (
            <option
              key={item}
              value={item}
              className="tw-bg-[#081120]"
            >
              {item}
            </option>
          ))}
        </select>

        <div className="tw-pointer-events-none tw-absolute tw-right-3 tw-top-1/2 tw--translate-y-1/2 tw-text-purple-300">
          ▼
        </div>
      </div>

      {/* AM PM */}
      <div
        className="
          tw-flex
          tw-overflow-hidden
          tw-rounded-xl
          tw-border
          tw-border-white/10
          tw-bg-white/5
        "
      >
        {["AM", "PM"].map((item) => {
          const active = period === item;

          return (
            <button
              key={item}
              onClick={() => setPeriod(item)}
              className={`
                tw-px-5
                tw-py-4
                tw-text-sm
                tw-font-bold
                tw-transition-all
                tw-duration-300

                ${
                  active
                    ? `
                      tw-bg-gradient-to-r
                      tw-from-cyan-500/30
                      tw-to-purple-500/30
                      tw-text-white
                    `
                    : `
                      tw-text-white/60
                      hover:tw-bg-white/5
                    `
                }
              `}
            >
              {item}
            </button>
          );
        })}
      </div>
    </div>
  );
}